import { useQuery } from "@rocicorp/zero/react"
import * as React from "react"
import type { Row } from "../../generated/schema.ts"
import * as queries from "../../shared/queries.ts"
import * as Auth from "../lib/auth.ts"

export function useThreadAccounts(props: useThreadAccounts.Props) {
  const { thread } = props
  const { data: authData } = Auth.useAuthData()
  const [threadAccounts] = useQuery(
    queries.threadAccounts(authData, {
      accountCount: thread.account_count,
      threadId: thread.id,
    }),
  )
  return React.useMemo(() => {
    // so we can order by accounts to post in the thread
    return threadAccounts.sort((a, b) =>
      (a.messages.at(0)?.inserted_at ?? 1) >
      (b.messages.at(0)?.inserted_at ?? 1)
        ? 1
        : -1,
    )
  }, [threadAccounts])
}

export declare namespace useThreadAccounts {
  type Props = {
    thread: Pick<Row.thread, "account_count" | "id">
  }
}
